// @flow
import * as React from 'react';
import get from 'lodash/get';

import { FormattedMessage } from 'react-intl';
import Location from '../../Location/Location.jobs';
import messages from '../../messages';
import { formatSecondsToRelativeTime } from '../../../utils/strings';
import { getLocationItemByVerticalName } from '../../../utils/schemaOrg';
import jobMessages from './messages';
import styles from './styles';

const { grossYear, newAd } = messages;

type Props = {
  ad: Object,
  searchParameters: Object,
  verticalName: string,
  intl: Object,
  withRichData?: ?boolean,
  wasVisited: boolean,
};

function SnippetJobs({
  ad,
  verticalName,
  intl,
  searchParameters,
  withRichData,
  wasVisited,
}: Props): React.Node {
  const timeAgoSeconds = ad.timeAgoSeconds;
  const title = ad.title;

  const location = ad.location;
  const verticalProperties = ad.verticalProperties;
  const isFresh = ad.fresh;
  const company = verticalProperties.company;
  const date = ad.date;
  const salary = verticalProperties.salary;
  const showLocation = location.city || location.region;
  const locationRichDataItem = getLocationItemByVerticalName(verticalName);

  return (
    <span className={`snippet${wasVisited ? ' visited' : ''}`}>
      <meta itemProp="title" content={title} />
      <meta
        itemProp="hiringOrganization"
        itemType="http://schema.org/Organization"
        content={company || 'Unspecified'}
      />
      <meta itemProp="datePosted" content={date} />
      <h2 itemProp="description">{title}</h2>

      {(company || showLocation) && (
        <div className="company_location" itemScope={withRichData} {...locationRichDataItem}>
          {company && <span className="company">{company}</span>}
          {showLocation && (
            <Location
              locationTerms={{ city: location.city, region: location.region }}
              displaySeparator={!!company}
            />
          )}
        </div>
      )}

      {ad.isSimilarContentAd && !ad.distanceFromWhere && (
        <p className="few-results-profession-message">
          <FormattedMessage
            {...jobMessages.fewResultsByProfession}
            values={{ '%1$s': get(searchParameters, 'what_d') }}
          />
        </p>
      )}

      {ad.isSimilarContentAd && ad.distanceFromWhere && (
        <p className="few-results-location-message">
          <FormattedMessage
            {...jobMessages.fewResultsByLocation}
            values={{ '%1$s': get(ad, ['distanceFromWhere', 'formatted']) }}
          />
        </p>
      )}

      {salary && (
        <p className="salary" itemProp="baseSalary" itemType="http://schema.org/MonetaryAmount">
          <FormattedMessage {...grossYear} />
          {': '}
          <span itemProp="value">{salary}</span>
        </p>
      )}

      <p className="date">
        {isFresh && (
          <span className="new" itemProp="datePosted">
            <FormattedMessage {...newAd} />
          </span>
        )}
        {formatSecondsToRelativeTime(timeAgoSeconds, intl)}
      </p>

      <style jsx>{styles}</style>
    </span>
  );
}

SnippetJobs.defaultProps = {
  withRichData: false,
};

export default SnippetJobs;



// WEBPACK FOOTER //
// ./app/common/Snippet/jobs/component.js